import { z } from "zod"

export enum AgoraWebhookEventType {
    CloudRecordingError = 1,
    CloudRecordingStatusUpdate = 3,
    CloudRecordingM3U8Created = 4,
    CloudRecordingUploaded = 31,
    CloudRecordingBackedUp = 32,
    STSExpired = 34,
    RecorderStarted = 40,
    RecorderLeave = 41,
    ChannelDestroy = 102,
    BroadcasterJoinChannel = 103,
    BroadcasterLeaveChannel = 104,
    AudienceJoinChannel = 105,
    AudienceLeaveChannel = 106,
}

export enum AgoraProductId {
    RealtimeCommunication = 1,
    CloudRecording = 3,
    MediaGateway = 10,
}

export enum AgoraMediaGatewayEventType {
    LiveStreamConnected = 1,
    LiveStreamDisconnected = 2,
    LiveStreamAborted = 3,
    LiveProfileUpdated = 4,
}

const agoraFileListSchema = z.array(z.object({ fileName: z.string() }).loose())

export const agoraWebhookSchema = z
    .object({
        productId: z.number().optional(),
        eventType: z.number(),
        notifyMs: z.number().optional(),
        payload: z
            .object({
                channelName: z.string().optional(),
                cname: z.string().optional(),
                rtcInfo: z.object({ channel: z.string() }).loose().optional(),
                // Channel events (102/103/104) carry `ts` in seconds; cloud-recording events
                // (4/31/32/41) carry `sendts` in milliseconds instead. Prefer notifyMs over
                // ts for precision.
                ts: z.number().optional(),
                sendts: z.number().optional(),
                details: z
                    .object({
                        // eventType 4 sends fileList as the bare m3u8 filename; 31/32 send an
                        // array of file objects.
                        fileList: z.union([z.string(), agoraFileListSchema]).optional(),
                    })
                    .loose()
                    .optional(),
            })
            .loose(),
    })
    .loose()

export type AgoraWebhook = z.infer<typeof agoraWebhookSchema>
